export const FETCH_DASHBOARD_SESSION_COUNT = 'FETCH_DASHBOARD_SESSION_COUNT';
export const FETCH_CONVERSATION_TURNS_COUNT = 'FETCH_CONVERSATION_TURNS_COUNT';
export const FETCH_QUIZ_SUMMARY_COUNT = 'FETCH_QUIZ_SUMMARY_COUNT';
export const FETCH_RATINGS_SUMMARY = 'FETCH_RATINGS_SUMMARY';
// export const FETCH_USER_FALLBACK_SUCCESS = 'FETCH_USER_FALLBACK_SUCCESS';
